function initialState() {
  return {
    plantOverview: {
      card: '#242c50',
      radial:  '',
      widget: '#242c50'
    }
  }
} 

const state = initialState()

const mutations = {
  SET_MODULE_VALUES(state, payload) {
    const { module, subModule, value } = payload
    state[module][subModule] = value
  },
  RESET_STATE(state) {
    const initial = initialState()
    Object.assign(state, initial)
  }
}

const actions = {
  setValue({commit}, payload) {
    commit('SET_MODULE_VALUES', payload)
  },
  restoreDefault({state}, module) {
    let defaultState = initialState()

    Object.keys(defaultState[module]).forEach(key => {
      state[module][key] = defaultState[module][key]
    })
  }
}

const getters = {
  getValue: state => (payload) => {
    const { module, subModule} = payload
    return state[module][subModule]
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
